<script lang="ts">
	import { onMount } from 'svelte';
	import type { EmblaCarouselType } from 'embla-carousel';
	import { checkVisibility } from './actions/checkVisibility';

	interface Props {
		embla: EmblaCarouselType;
		count: number;
		active: number;
		theme?: 'default' | 'brown';
		class?: string;
	}

	let { embla, count, active, theme = 'default', class: className }: Props = $props();

	let indicators = $derived(Array.from({ length: count }).map((_, i) => i));

	const DEFAULT_DURATION = 4000;

	let playing = $state(false);
	let duration = $state(DEFAULT_DURATION);

	function handlePlay(api: EmblaCarouselType) {
		const pluginDelay = api.plugins().autoplay.options.delay;
		duration = typeof pluginDelay === 'number' ? pluginDelay : DEFAULT_DURATION;
		playing = true;
	}

	function handleStop() {
		playing = false;
	}

	let initial = $state(true);

	onMount(() => {
		playing = embla.plugins().autoplay.isPlaying();

		embla.on('autoplay:play', handlePlay);
		embla.on('autoplay:stop', handleStop);

		return () => {
			embla.off('autoplay:play', handlePlay);
			embla.off('autoplay:stop', handleStop);
		};
	});
</script>

<div
	class="flex justify-center {className || ''}"
	use:checkVisibility
	onvisible={({ detail }) => {
		if (detail && initial) {
			initial = false;
		}
	}}
>
	<div class="flex items-center gap-x-2">
		{#each indicators as index}
			{@const isActive = active === index}
			<button
				type="button"
				onclick={() => embla.scrollTo(index)}
				aria-label="Go to slide {index + 1}"
				class={[
					'relative h-[6px] overflow-hidden rounded-full bg-black/[0.24] backdrop-blur transition-width duration-500',
					{
						'w-8': isActive && playing,
						'w-1.5': !isActive || !playing
					}
				]}
			>
				<span
					style={playing ? `transition-duration: ${isActive ? duration : 250}ms` : null}
					class={[
						'absolute inset-0 rounded-full',
						{
							'transition-transform ease-linear': playing,
							'bg-stone-5': theme === 'default',
							'bg-brown-1': theme === 'brown',
							'translate-x-8': initial || !isActive
						}
					]}
				>
				</span>
			</button>
		{/each}
	</div>
</div>
